import request from '@/common/request'

export default {
    /**
     * 根据机构查询钥匙列表
     *
     * @param orgCode 钥匙当前所属机构
     * @return 列表结果
     */
    getKeysByOrgCode: orgCode => {
        return request({
            url: `/v1/keyManage/keysByOrgCode/${orgCode}`,
            method: 'get'
        })
    },
    /**
     *  create 增
     *  delete 删
     *  update 改
     *  query  查
     */
    createKeyManage: (dynaSeg, data, params) => {
        return request({
            url: '/v1/keyManage',
            method: 'post',
            data,
            params
        })
    },
    deleteKeyManage: (dynaSeg, data, params) => {
        return request({
            url: `/v1/keyManage/${dynaSeg.id}`,
            method: 'delete',
            data,
            params
        })
    },
    updateKeyManage: (dynaSeg, data, params) => {
        return request({
            url: "/v1/keyManage",
            method: 'patch',
            data,
            params
        })
    },
    queryKeyManage: (params) => {
        return request({
            url: '/v1/keyManage',
            method: 'get',
            params
        })
    },
    // 上缴POST
    turnInKey: (params,data) => {
        return request({
            url: `/v1/keyManage/turnInKey?keyId=${params.keyId}`,
            method: 'post',
            data
        })
    },
    showKeyInfo: params => {
        return request({
            url: '/v1/keyManage/keyInfos',
            method: 'get',
            params
        })
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/keyManage.js